import React, { useState, createContext, useContext } from 'react';
import LoadingData from '../../components/loading/LoadingData';

export const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [loadingData, setLoadingData] = useState(false);

    return (
        <LoadingContext.Provider value={{ setLoadingData }}>
            <>
                {children}
                {loadingData && <LoadingData />}
            </>
        </LoadingContext.Provider>
    );
};

export const useLoadingContext = () => {
  return useContext(LoadingContext);
};